import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7eb9057e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "table sm:flex sm:flex-wrap" }
const _hoisted_3 = { class: "dt" }
const _hoisted_4 = { class: "dd" }
const _hoisted_5 = { class: "dt" }
const _hoisted_6 = { class: "dd" }
const _hoisted_7 = { class: "dt" }
const _hoisted_8 = { class: "dd" }
const _hoisted_9 = {
  key: 1,
  class: "dl"
}
const _hoisted_10 = { class: "dt" }
const _hoisted_11 = { class: "dd" }
const _hoisted_12 = {
  key: 2,
  class: "dl"
}
const _hoisted_13 = { class: "dt" }
const _hoisted_14 = { class: "dd" }
const _hoisted_15 = {
  key: 3,
  class: "w-full lg:w-1/3 mb-x4"
}
const _hoisted_16 = { class: "dt" }
const _hoisted_17 = {
  key: 0,
  class: "block mb-x1"
}
const _hoisted_18 = { class: "dd" }

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import ProductFactSheetDownload from '@/shared/navigation/pdf-link/ProductFactSheetDownload.vue';
import { computed } from 'vue';
import useProductSpecificationsData from '@/shared/product/details/ui/product-specifications/useProductSpecificationsData';
import TruncateText from '@/shared/navigation/TruncateText.vue';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import PdfLinkDownload from '@/shared/navigation/pdf-link/PdfLinkDownload.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSpecificationsDetails',
  setup(__props) {

const { variantId, specifications } = useProductSpecificationsData();

const isMobile = computed(() => breakpointsState.activeBreakpoint === 'xs');

const showWarranty = computed(() => labels.warrantyHeading && labels.warrantyDescription);
const showDownloads = computed(() => (specifications.value?.downLoads && specifications.value?.downLoads.length > 0) || specifications.value?.hasProductFactSheet);
const showEan = computed(() => specifications.value?.ean);
const showCollis = computed(() => labels.parcelMeasurements && specifications.value?.collis && specifications.value?.collis.length > 0);
const productSpecificationsFiltered = computed(() => specifications.value?.productSpecificationAttributes?.filter(v => !!v.value));
const productInformationFiltered = computed(() => specifications.value?.productInformationAttributes?.filter(v => !!v.value));
const collisFiltered = computed(() => specifications.value?.collis?.filter(v => (v.unitVolume || v.grossWeight || v.depth || v.width || v.height)));
const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(isMobile) ? TruncateText : 'div'), {
      "button-class": "mt-x2",
      "teaser-height": 185,
      "read-more-label": _unref(labels).showAllSpecifications,
      "read-less-label": _unref(labels).hideSpecifications
    }, {
      default: _withCtx(() => [
        _createElementVNode("dl", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productSpecificationsFiltered), (spec) => {
            return (_openBlock(), _createElementBlock("div", {
              key: spec.label,
              class: "dl"
            }, [
              _createElementVNode("dt", _hoisted_3, _toDisplayString(spec.label), 1),
              _createElementVNode("dd", _hoisted_4, _toDisplayString(spec.value), 1)
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productInformationFiltered), (spec) => {
            return (_openBlock(), _createElementBlock("div", {
              key: spec.label,
              class: "dl"
            }, [
              _createElementVNode("dt", _hoisted_5, _toDisplayString(spec.label), 1),
              _createElementVNode("dd", _hoisted_6, _toDisplayString(spec.value), 1)
            ]))
          }), 128)),
          (_unref(showCollis))
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(collisFiltered), (col) => {
                return (_openBlock(), _createElementBlock("dl", {
                  key: col.id,
                  class: "dl"
                }, [
                  _createElementVNode("dt", _hoisted_7, _toDisplayString(_unref(labels).parcelMeasurements) + " " + _toDisplayString(col.number), 1),
                  _createElementVNode("dd", _hoisted_8, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).parcelMeasurementsDetails, { unitVolume: col.unitVolume, grossWeight: col.grossWeight, depth: col.depth, width: col.width, height: col.height })), 1)
                ]))
              }), 128))
            : _createCommentVNode("", true),
          (_unref(showEan))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("dt", _hoisted_10, _toDisplayString(_unref(labels).ean), 1),
                _createElementVNode("dd", _hoisted_11, _toDisplayString(_unref(specifications)?.ean), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(showWarranty))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("dt", _hoisted_13, _toDisplayString(_unref(labels).warrantyHeading), 1),
                _createElementVNode("dd", _hoisted_14, _toDisplayString(_unref(labels).warrantyDescription), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(showDownloads))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("dt", _hoisted_16, _toDisplayString(_unref(labels).downloadHeading), 1),
                (_unref(specifications)?.hasProductFactSheet && _unref(variantId))
                  ? (_openBlock(), _createElementBlock("dd", _hoisted_17, [
                      _createVNode(ProductFactSheetDownload, { sku: _unref(variantId) }, null, 8, ["sku"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("dd", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(specifications)?.downLoads, (download) => {
                    return (_openBlock(), _createBlock(PdfLinkDownload, {
                      key: download.label,
                      class: "block mb-x1",
                      "is-direct-link": true,
                      label: _unref(labels)[download.label],
                      url: download.url
                    }, null, 8, ["label", "url"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["read-more-label", "read-less-label"]))
  ]))
}
}

})